import reducerRegistry from '../../reducers/ReducerRegistry';
import { checkoutReducer } from './reducers';
export { pickupsSelector } from './selectors';
reducerRegistry.register({
    checkout: checkoutReducer,
});
